import { Skeleton } from '@/components/ui/skeleton';
import { PendingRegion } from '@/shared/components/PendingRegion';

/**
 * A file pane while it loads (spec 079 US2).
 *
 * `rows` distinguishes the two panes that use it: history is a list of revisions, preview
 * is one document. Same shape, different counts — a parameter rather than two components,
 * because the difference genuinely is a number.
 *
 * The count is fixed and short (research D7): the true length is unknowable while pending,
 * and a placeholder that guesses long pulls content upward past the fold when the truth
 * arrives, which disturbs more than growing downward into empty space.
 */
export function FilePaneSkeleton({
  label,
  rows = 5,
}: {
  label: string;
  rows?: number;
}) {
  return (
    <PendingRegion label={label} className="gap-3 p-4">
      {Array.from({ length: rows }, (_, row) => (
        <Skeleton key={row} className="h-10 w-full" />
      ))}
    </PendingRegion>
  );
}
